<div xpoDialog>
  <h1 mat-dialog-title>
    {{ title }}
    <xpo-dialog-close-button></xpo-dialog-close-button>
  </h1>

  <div mat-dialog-content>
    <div class="xpo-Alert">
      <div class="xpo-Alert-content">
        <div [innerHtml]="message"></div>
      </div>
    </div>
  </div>

  <div mat-dialog-actions>
    <button mat-flat-button xpoButton (click)="dialogRef.close()">Ok</button>
  </div>
</div>
